/**
 * DatePicker minimalista basado en input[type=date] nativo.
 * Evita dep react-day-picker en MVP; mismo valor ISO YYYY-MM-DD.
 */
import * as React from "react";
import { cn } from "@/lib/utils";

export interface DatePickerProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, "type"> {}

export const DatePicker = React.forwardRef<HTMLInputElement, DatePickerProps>(
  ({ className, ...props }, ref) => (
    <input
      type="date"
      ref={ref}
      className={cn(
        "flex h-10 w-full rounded-lg border border-ink-200 dark:border-ink-700 bg-white dark:bg-ink-900 px-3 py-2 text-sm placeholder:text-ink-400 focus:outline-none focus:ring-2 focus:ring-brand-500 disabled:cursor-not-allowed disabled:opacity-50",
        className,
      )}
      {...props}
    />
  ),
);
DatePicker.displayName = "DatePicker";

export interface DateTimePickerProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, "type"> {}

export const DateTimePicker = React.forwardRef<HTMLInputElement, DateTimePickerProps>(
  ({ className, ...props }, ref) => (
    <input
      type="datetime-local"
      ref={ref}
      className={cn(
        "flex h-10 w-full rounded-lg border border-ink-200 dark:border-ink-700 bg-white dark:bg-ink-900 px-3 py-2 text-sm placeholder:text-ink-400 focus:outline-none focus:ring-2 focus:ring-brand-500 disabled:cursor-not-allowed disabled:opacity-50",
        className,
      )}
      {...props}
    />
  ),
);
DateTimePicker.displayName = "DateTimePicker";
